module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/atom.0208698f.png";